import { useState } from 'react';
import { useAckCelebration, useCelebrations } from '../../api/hooks';
import { Medallion } from './Medallion';
import { haptics } from '../../telegram';
import { track } from '../../analytics';
import type { Celebration } from '../../api/types';

/**
 * «Момент получения» (C1): bottom-sheet поверх приложения, когда у игрока есть
 * непоказанные уровни. Несколько — пейджер точками; «Забрать» ack'ает текущий.
 * Монтируется в App.tsx; сервер каппит очередь (10) и не выдаёт ретро-начисления
 * (suppressCelebrations при recalc-all).
 */
export function CelebrationSheet({ enabled }: { enabled: boolean }) {
  const celebrations = useCelebrations(enabled);
  const ack = useAckCelebration();
  const [dismissed, setDismissed] = useState<string[]>([]);
  const [index, setIndex] = useState(0);

  const items = (celebrations.data ?? []).filter(
    (c) => !dismissed.includes(key(c)),
  );
  if (!enabled || items.length === 0) return null;
  const current = items[Math.min(index, items.length - 1)];

  const take = () => {
    haptics.success();
    track('celebration_ack', { id: current.achievementId, level: current.level });
    void ack.mutateAsync({ achievementId: current.achievementId, level: current.level }).catch(() => undefined);
    setDismissed((d) => [...d, key(current)]);
    setIndex(0);
  };

  return (
    <div className="sheet-backdrop ach-celebrate-backdrop">
      <div className="sheet ach-celebrate" data-theme="dark" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-handle" />
        <div className="ach-celebrate-label">Новое достижение</div>
        <div className="ach-celebrate-medallion">
          <span className="sparks" aria-hidden>
            <i /><i /><i /><i /><i /><i />
          </span>
          <Medallion icon={current.icon} level={current.level} maxLevel={current.maxLevel}
            progress={1} size={84} glow />
        </div>
        <div className="ach-celebrate-name">{current.name}</div>
        <div className="ach-celebrate-level">
          {current.levelTitle ??
            (current.maxLevel > 1 ? `Уровень ${current.level}` : 'Получено')}{' '}
          · +{current.points} очков
        </div>
        {items.length > 1 && (
          <div className="ach-celebrate-dots">
            {items.map((c, i) => (
              <button
                key={key(c)}
                className={i === Math.min(index, items.length - 1) ? 'on' : ''}
                onClick={() => setIndex(i)}
                aria-label={`Достижение ${i + 1}`}
              />
            ))}
          </div>
        )}
        <button className="btn ach-celebrate-take" onClick={take}>
          Забрать
        </button>
      </div>
    </div>
  );
}

function key(c: Celebration): string {
  return `${c.achievementId}:${c.level}`;
}
